import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Button } from '@alifd/next';
import styles from './index.module.scss';
const FoodList = (props) => {
 const [color,setColor]=useState("#b8c2bf")
 const [color1,setColor1]=useState("#b8c2bf")
 const [color2,setColor2]=useState("#b8c2bf")
 const [color3,setColor3]=useState("#b8c2bf")
 const [color4,setColor4]=useState("#b8c2bf")
 const [color5,setColor5]=useState("#b8c2bf")
 const [color6,setColor6]=useState("#b8c2bf")
 const [color7,setColor7]=useState("#b8c2bf")
 const [color8,setColor8]=useState("#b8c2bf")
 const [color9,setColor9]=useState("#b8c2bf")
 const [color10,setColor10]=useState("#b8c2bf")
 const [color11,setColor11]=useState("#b8c2bf")
 const [color12,setColor12]=useState("#b8c2bf")
 const [color13,setColor13]=useState("#b8c2bf")
 const [color14,setColor14]=useState("#b8c2bf")
 const [color15,setColor15]=useState("#b8c2bf")
 const [colorStatus,setColorStatus]=useState(false)
  return (
    <>
      <div  className={styles.title}>送件處</div>
      <div className={styles.box}>
        <div className={styles.text} style={{background:color,color:"#FFF" }} onClick={()=>{setColor("#69b49e")}}>執行長室</div>
        <div className={styles.text} style={{background:color1,color:"#FFF" }} onClick={()=>{setColor1("#69b49e")}}>廁所</div>
        <div  className={styles.text} style={{background:color2,color:"#FFF" }} onClick={()=>{setColor2("#69b49e")}}>會計部</div>
        <div  className={styles.text} style={{background:color3,color:"#FFF" }} onClick={()=>{setColor3("#69b49e")}}>會議室</div>
      </div>
      <div  className={styles.box}>
        <div  className={styles.text} style={{background:color4,color:"#FFF" }} onClick={()=>{setColor4("#69b49e")}}>標章部</div>
        <div className={styles.text}  style={{background:color5,color:"#FFF" }} onClick={()=>{setColor5("#69b49e")}}>走道一</div>
        <div  className={styles.text}  style={{background:color6,color:"#FFF" }} onClick={()=>{setColor6("#69b49e")}}>走道二</div>
        <div className={styles.text}  style={{background:color7,color:"#FFF" }} onClick={()=>{setColor7("#69b49e")}}>門口</div>
      </div>
      <div  className={styles.title}>收件處</div>
      <div className={styles.box}>
        <div  className={styles.text} style={{background:color8,color:"#FFF" }} onClick={()=>{setColor8("#69b49e")}}>執行長室</div>
        <div  className={styles.text}  style={{background:color9,color:"#FFF" }} onClick={()=>{setColor9("#69b49e")}}>廁所</div>
        <div  className={styles.text}  style={{background:color10,color:"#FFF" }} onClick={()=>{setColor10("#69b49e")}}>會計部</div>
        <div  className={styles.text} style={{background:color11,color:"#FFF" }} onClick={()=>{setColor11("#69b49e")}}>會議室</div>
      </div>
      <div  className={styles.box}>
        <div  className={styles.text} style={{background:color12,color:"#FFF" }} onClick={()=>{setColor12("#69b49e")}}>標章部</div>
        <div  className={styles.text} style={{background:color13,color:"#FFF" }} onClick={()=>{setColor13("#69b49e")}}>走道一</div>
        <div className={styles.text} style={{background:color14,color:"#FFF" }} onClick={()=>{setColor14("#69b49e")}}>走道二</div>
        <div  className={styles.text} style={{background:color15,color:"#FFF" }} onClick={()=>{setColor15("#69b49e")}}>門口</div>
        <div  className={styles.btn}  >送出</div>
  
      </div>
      

    </>
  );
};

export default FoodList;
